const refs = {
  productsList: document.querySelector('.products-list'),
  logoLink: document.querySelector('.logo-link'),
  searchBtn: document.querySelector('.bi-search'),
  searchForm: document.querySelector('.search-form'),
  loginCloseModalBtn: document.querySelector('.js-loginBtnClose'),
  loginModalBackdrop: document.querySelector('.js-loginBackdrop'),
  loginSignIn: document.querySelector('.js-SignIn'),
  registerCloseModalBtn: document.querySelector('.js-registerBtnClose'),
  registerModalBackdrop: document.querySelector('.js-registerBackdrop'),
  registerSignUp: document.querySelector('.js-SignUp'),
  menuContainer: document.querySelector('.menu-list-container'),
  userBar: document.querySelector('.menu-user-link'),
  closeModalBtn: document.querySelector('.movieModalClose'),
  modalBackdrop: document.querySelector('.js-movieModal'),
  modalContainer: document.querySelector('.movieModal'),
  movieWrap: document.querySelector('.movieModalWrap'),
  spinner: document.querySelector('#spinner'),
  teamModal: document.querySelector('.team_list'),
  teamModalBtnOpen: document.querySelector('.team__modal'),
  teamModalBtnClose: document.querySelector('.teamModalBtnClose'),
  teamModalBackdrop: document.querySelector('.teamModalBack'),
  renderListRef: document.querySelector('.products-list-js'),
  formMessageref: document.querySelector('.js-btn-reg'),
  signinFormRef: document.querySelector('.registerForm'),
  userSpanRef: document.querySelector('.js-userSpan'),
  userAuthRef: document.querySelector('.js-userAuth'),
  loginFormRef: document.querySelector('.loginForm'),
  btnSignOutRef: document.querySelector('.js-SignOut'),
  BtnWatchRef: document.querySelector('.js-watched-col'),
  BtnQueueRef: document.querySelector('.js-queue-col'),
  movieModalSpan: document.querySelector('.movie-modal-span'),
  themeTogglerLink: document.querySelector('.theme-toggler-link'),
  body: document.querySelector('body'),
  movieHeader: document.querySelectorAll('.products-name'),
  allTheButtons: document.querySelector('button'),
  footer: document.querySelector('footer'),
  footerText: document.querySelector('.footer_container'),
  footerTextTeam: document.querySelector('.team__modal'),
  registerFromLogin: document.querySelector('.registerFromLogin'),
  regError: document.querySelector('.reg-error'),
  registerFormName: document.getElementById('registerFormName'),
  registerFormPassword: document.getElementById('registerFormPassword'),
  theme: localStorage.getItem('theme'),
};

export default refs;
